import { Box } from "@mui/system";
import React, { useState } from "react";
import styles from "./actionComponent.module.scss";
import _ from "lodash";
import CustomPopover from "../../../../components/customPopover/CustomPopover";
import {  Paper } from "@mui/material";
import i18next from "i18next";
import PropTypes from "prop-types";

const ActionComponent = (props) => {
  const { content, customClass = null, dealerDetails,handleDeleteClick,handleRemoveClick, inGroupTable } = props;
  const dealer_Id = _.get(dealerDetails, "dealer_Id", 0);

  const [actionPopoverId, setActionPopoverId] = useState(null);

  const [actionPopoverOpen, setActionPopoverOpen] = useState(false);
  const actionAnchorRef = React.useRef(null);
  // const history = useNavigate(); - needed later

  const handleActionClick = () => {
    const newOpen = !actionPopoverOpen;
    setActionPopoverOpen(newOpen);
    setActionPopoverId(newOpen ? `action-popover-${dealer_Id}` : null);
  };


  const handleActionPopoverClose = () => {
    setActionPopoverOpen(false);
  };
  // const handleMenuClickDemo = () => {- needed later
  //   // just for dem purpose chnage asper requirment
  //   history("/profile");
  //   handleActionPopoverClose();
  // };
 

  return (
    <>
      <Box
        className={`${styles.actionComponentWrapper} ${styles[customClass]}`}
        data-testid="status-text"
        ref={actionAnchorRef}
        aria-describedby={`action-popover-${dealer_Id}`}
        variant="contained"
        onClick={(e) => handleActionClick()}
      >
        {content}
      </Box>
      <CustomPopover
        anchorEl={actionAnchorRef}
        handleClose={() => handleActionPopoverClose()}
        open={actionPopoverOpen}
        id={actionPopoverId}
        hasArrow={true}
        arrowPosition={"right"}
        customPlacement="bottom"
        content={
          <Box className={styles.dropDownMenu}>
            <Paper>
              {/* needed later - if not needed till live remove */}
              {/* <Box
                className={styles.menuItem}
                onClick={() => handleMenuClickDemo()}
              >
                <Box className={styles.menuItemContent}>
                  <span className={styles.iconExport}></span>
                  {i18next.t("Export vehicle list")}
                </Box>
              </Box>
              <Divider variant="middle" />
              <Box
                className={styles.menuItem}
                onClick={() => handleMenuClickDemo()}
              >
                <Box className={styles.menuItemContent}>
                  <span className={styles.iconLog}></span>
                  {i18next.t("Export logs")}
                </Box>
              </Box>
              <Divider variant="middle" /> */}

              {inGroupTable ? (
                <Box
                  className={styles.menuItem}
                  onClick={() => handleRemoveClick()}
                >
                  <Box className={styles.menuItemContent}>
                    <span className={styles.iconRemove}></span>
                    {i18next.t("Remove from group")}
                  </Box>
                </Box>
              ) : (
                <Box
                  className={styles.menuItem}
                  onClick={() => handleDeleteClick()}
                >
                  <Box className={styles.menuItemContent}>
                    <span className={styles.iconTrash}></span>
                    {i18next.t("Delete")}
                  </Box>
                </Box>
              )}
            </Paper>
          </Box>
        }
      />
    </>
  );
};
export default ActionComponent;
ActionComponent.propTypes = {
  content:PropTypes.any, 
  customClass:PropTypes.any, 
  dealerDetails:PropTypes.any,
  handleDeleteClick:PropTypes.any
}